import React from 'react'
import Link from 'gatsby-link'
import Logo from '../assets/logo-with-address.svg'
import LeftCorner from '../assets/left-corner.svg'
import RightCorner from '../assets/right-corner.svg'

const IndexPage = () => (
  <div style={{ zIndex: 1000 }}>
    <div style={{ margin: 'auto', paddingTop: 10, width: '50%' }}>
      <img src="/logo.png" />
    </div>

    <div
      style={{
        margin: 'auto',
        width: '50%',
        textAlign: 'center',
        color: 'white',
      }}
    >
      <h4>You are invited to celebrate</h4>
      <h2 style={{ fontWeight: 'bold', fontSize: '3em' }}>
        Natalia's Birthday
      </h2>
      <h2 style={{ fontWeight: 'bold', fontSize: '2em' }}>
        Party will start at 19:00
      </h2>
      <h4>Friday July 20</h4>
      <h4>BigFish at Bomo Grand Resort Hotel</h4>
      <h4>
        {' '}
        <a href="https://goo.gl/maps/TyHiQbPMBCJ2" style={{ color: 'pink' }}>
          <img
            src="/maps.png"
            width="30"
            height="30"
            style={{ display: 'inline', marginBottom: 0 }}
          />
          https://goo.gl/maps/TyHiQbPMBCJ2
        </a>
      </h4>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js